import React, {Component} from "react";
import {Col, Container, Row, Form} from "react-bootstrap";

export default class ReferralInsuranceTab extends Component {

    maxCoPayTemplate(referral) {
        return <Form.Control
            type="number"
            step="0.01"
            placeholder="max co-pay"
            style={{ fontSize: '14px', padding: '10px', borderRadius: '8px' }}
            value={referral.coPayMax || ''}
            disabled={this.props.readOnly}
            onChange={(e) => {
                const value = e.target.value ? parseFloat(e.target.value) : null;
                if (this.props.onReferralChange) {
                    this.props.onReferralChange(referral.id, 'coPayMax', value);
                }
            }}
        />
    }

    render() {
        const insurance = this.props.referral.patient.insurance;
        return <Container>
            <Row>
                <Col>
                    <Field label={"TPA/Company"} body={insurance ? `${insurance.tpa?.name}/${insurance.company?.name}` : ""}/>
                </Col>
                <Col>
                    <Field label={"Max Co-Pay"} body={this.maxCoPayTemplate(this.props.referral)} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Field label={"MemberId"} body={insurance?.memberId} />
                </Col>
                <Col>
                    <Field label={"Emirates ID"} body={this.props.referral.patient.eid} />
                </Col>
            </Row>
        </Container>
    }
}

class Field extends Component {
    render() {
        const {label, body} = this.props;
        return <div style={{display: 'flex', alignItems: 'center', marginBottom: 8, gap: '10px'}}>
            <div><b>{label}:</b></div>
            <div>{body}</div>
        </div>;
    }
}